export const JitPaths = {
  Activity: "activity",
  History: "history",
  PreApprovals: "pre-approvals",
} as const;
